import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import './onboarding.css'

const OnboardingFinal = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const start = () => {
    navigate('/app/people')
  }

  return (
    <div className="onboarding-page">
      <div className="onboarding-content">
        <img className="square-hero" src="/Pic3.png" alt="" />
        <h1 className="h1">{t('onboarding.finalMatchesReady')}</h1>
        <p className="p">
          {t('onboarding.finalSubtitle')}
        </p>
      </div>
      <button className="cta-fixed" onClick={start}>
        {t('onboarding.startExploring')}
      </button>
    </div>
  )
}

export default OnboardingFinal
